import { jsx } from 'react/jsx-runtime';
import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { titleStyle } from '../dialog.vanilla.mjs';

const Title = forwardRef(
  ({ className, ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      AlertDialogPrimitive.Title,
      {
        "data-scope": "dialog",
        "data-part": "title",
        ref,
        className: classNames(className, titleStyle),
        ...props
      }
    );
  }
);

export { Title };
//# sourceMappingURL=Title.mjs.map
